import { Accordion } from "react-bootstrap";

import { humanizeKey } from "../utils/content.utils";
import { ObjectFieldEditor } from "./ValueEditor";

const SectionEditor = ({
  section,
  disabled = false,
  onChange,
  onUploadStart,
  onUploadEnd,
}) => {
  if (!section || typeof section !== "object") return null;

  const sectionId = section.id || "section";
  const title = humanizeKey(sectionId);

  return (
    <Accordion.Item eventKey={String(sectionId)}>
      <Accordion.Header>{title}</Accordion.Header>
      <Accordion.Body>
        <ObjectFieldEditor
          value={section}
          disabled={disabled}
          onChange={onChange}
          onUploadStart={onUploadStart}
          onUploadEnd={onUploadEnd}
          depth={0}
          hideId
          excludeKeys={["id"]}
        />
      </Accordion.Body>
    </Accordion.Item>
  );
};

export default SectionEditor;
